jQuery(document).ready(function ($) {
  //dropdown meag menus

  $(".mega-menu").attr("open", "true");
  $(".mega-menu").click(function (e) {
    e.preventDefault();
    $(".mega-menu").attr("open", "true");
    if ($(this).hasClass("expand")) {
      if ($(e.target).closest(".header__menu-item").length) {
        $(this).removeClass("expand");
        $(
          "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
        ).removeClass("expand");
        $("#Details-HeaderMenu-1 .mega-menu__list ul").slideUp();
        $(
          "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
        ).removeClass("active");

        $("header").removeClass("header_overlay_2");
        // $("body").css("overflow-y", "unset");
        $("html").css("overflow", "unset");
      }
    } else {
      $(
        "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
      ).removeClass("expand");
      $("#Details-HeaderMenu-1 .mega-menu__list ul").slideUp();
      $(
        "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
      ).removeClass("active");
      $(".mega-menu").removeClass("expand");
      $(this).addClass("expand");

      $("header").addClass("header_overlay_2");
      // $("body").css("overflow-y", "hidden");
      $("html").css("overflow", "hidden");
    }
  });
  // //making anchor links inside the dropdown menu clickable which
  // //is beng prevented by prevent default
  $("ul.list-unstyled")
    .find("a")
    .on("click touchend", function (e) {
      var el = $(this);
      var link = el.attr("href");
      window.location = link;
    });
  $("ul.mega-menu__list")
    .find("a.no_more_child")
    .on("click touchend", function (e) {
      var el = $(this);
      var link = el.attr("href");
      window.location = link;
    });
  $(window).click(function (e) {
    if (!$(e.target).closest(".expand").length) {
      // Check if the clicked element is not a descendant of an element with the class .expand
      $(".expand").attr("open", "true");
      $(".mega-menu").removeClass("expand");
      $(
        "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
      ).removeClass("expand");
      $("#Details-HeaderMenu-1 .mega-menu__list ul").slideUp();
      $(
        "#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child"
      ).removeClass("active");

      $("header").removeClass("header_overlay_2");
      // $("body").css("overflow-y", "unset");
      $("html").css("overflow", "unset");
    }
  });

  //header removing page-width class
  function removeHeaderClass() {
    if ($(window).width() <= 1410) {
      // If screen width is less than 1410px, remove the class
      $(".header").removeClass("page-width");
    } else {
      // If screen width is 1410px or greater, add the class back (if needed)
      $(".header").addClass("page-width");
    }
  }
  // Initial check on page load
  removeHeaderClass();

  // Listen for window resize events
  $(window).resize(function () {
    // Recheck and remove the class when the window is resized
    removeHeaderClass();
  });

  //header adding box shadow on scroll
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 25) {
      $(".section-header").addClass("scrolled-past-header");
    } else {
      $(".section-header").removeClass("scrolled-past-header");
    }
  });
  var scroll = $(window).scrollTop();
  if (scroll >= 25) {
    $(".section-header").addClass("scrolled-past-header");
  } else {
    $(".section-header").removeClass("scrolled-past-header");
  }

  //megamenu level 2 anchor tag click for shop menu
  $("#Details-HeaderMenu-1 .mega-menu__link--level-2.has_more_child").click(
    function (event) {
      event.preventDefault();
      if ($(this).hasClass("expand")) {
        // $(this).removeClass("expand");
        $(this).removeClass("expand");
        $(this).next("ul").slideUp();
        $(this).removeClass("active");
      } else {
        // $("#Details-HeaderMenu-1 .mega-menu__list ul").slideUp();
        $(this).addClass("expand");
        $(this).next("ul").slideDown();
        $(this).addClass("active");
      }
    }
  );

  //adding active class to all the second level menus in brand dropdown menu
  $("#Details-HeaderMenu-2 .mega-menu__link--level-2.has_more_child").addClass(
    "active"
  );
  $("#Details-HeaderMenu-2 .mega-menu__link--level-2.has_more_child").css(
    "cursor",
    "unset"
  );

  //faq dropdown
  $(".faq_block").click(function () {
    if ($(this).hasClass("current")) {
      $(this).removeClass("current");
      $(this).find(".answer").slideUp();
    } else {
      $(".faq_block").removeClass("current");
      $(".faq_block .answer").slideUp();
      $(".faq_block .answer").addClass("current");
      $(this).addClass("current");
      $(this).find(".answer").slideDown();
    }
  });
  $(".faq_block:first").addClass("current");
  $(".faq_block:first").find(".answer").slideDown();

  // disabling checkout if required checkbox
  $(".cart__check .cart__checkout-button").addClass("disabled");
  if ($("body").hasClass("cartpg_cart")) {
    $(".cart__check .cart__checkout-button").click(function (e) {
      if ($(this).hasClass("disabled")) {
        e.preventDefault();
      }
    });
  }
  //inital page load check
  if (
    $("#required_privacy").is(":checked") &&
    $("#required_shipping").is(":checked")
  ) {
    $(".cart__check .cart__checkout-button").css("display", "block");
    $(".cart__check .cart__checkout-button").removeClass("disabled");
  } else {
    $(".cart__check .cart__checkout-button").css("display", "none");
    $(".cart__check .cart__checkout-button").addClass("disabled");
  }
  // Function to check for value changes in hidden inputs
  $(".cart_checkbox").change(function () {
    // Check if the checkbox is checked
    if (
      $("#required_privacy").is(":checked") &&
      $("#required_shipping").is(":checked")
    ) {
      $(".cart__check .cart__checkout-button").css("display", "block");
      $(".cart__check .cart__checkout-button").removeClass("disabled");
    } else {
      $(".cart__check .cart__checkout-button").css("display", "none");
      $(".cart__check .cart__checkout-button").addClass("disabled");
    }
  });

  //adding heart icon class to wishlist nav icon
  $(".header .hulk-wishlist-icon").addClass("header__icon");

  //showing newsletter
  // Function to set a cookie
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  // Function to get the value of a cookie
  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
      var c = cookieArray[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return parseInt(c.substring(name.length, c.length));
      }
    }
    return null;
  }
  
  

  // Check if the user closed the modal within the last 3 days
  // var lastClosedTime = getCookie('modalClosedTime');
  // var currentTime = new Date().getTime();

  // if (!lastClosedTime || currentTime - lastClosedTime > 3 * 24 * 60 * 60 * 1000) {
  //   // If the modal has not been closed within the last 3 days, show it initially
  //   $("body").addClass("overflow_hidden");
  //   $("#modalOverlay_2").fadeIn();
  // }
  


  // Flag to keep track of whether the popup has been shown
  var popupShown = false;

  // Function to show the popup
  function showPopup() {
      // Check if the popup has already been shown or closed within the last 3 days
      console.log("shoppopup");
      if (!popupShown) {
          var lastClosedTime = getCookie('modalClosedTime');
          var currentTime = new Date().getTime();

          if (!lastClosedTime || currentTime - lastClosedTime > 3 * 24 * 60 * 60 * 1000) {
              // If the modal has not been closed within the last 3 days, show it
              $("body").addClass("overflow_hidden");
              $("#modalOverlay_2").fadeIn();
              popupShown = true;
          }
      }
  }

  // Attach scroll event listener to window
  $(window).on("scroll", showPopup);

  // Set up event handler for closing the modal
  $("#closeModal_2").on("click", function () {
    // Set a cookie with the current time when the modal is closed
    setCookie('modalClosedTime', new Date().getTime(), 3);
    $("body").removeClass("overflow_hidden");
    $("#modalOverlay_2").fadeOut();
    $("#customModal").hide();
  });

  //refreshing page after variant is selected
  // Function to extract variant value from URL
  function getVariantFromUrl() {
    try {
        // Get the current URL
        var currentUrl = window.location.href;
        
        // Use regular expression to extract the variant value
        var variantRegex = /[?&]variant=([^&#]*)/i;
        var match = variantRegex.exec(currentUrl);
        var variantValue = match && decodeURIComponent(match[1].replace(/\+/g, ' '));

        return variantValue;
    } catch (error) {
        console.error('Error parsing URL:', error);
        return null;
    }
  }

  // Function to print variant value and reload the page
  function printVariantAndReload() {
    var variantValue = getVariantFromUrl();
    console.log('Variant value:', variantValue);
    if (variantValue !== null) {
      // Append the variant value to the current URL
      var newUrl = window.location.origin + window.location.pathname + '?variant=' + variantValue;
      // Reload the page with the new URL
      window.location.href = newUrl;
    }
  }

  // Attach click event listener to variant radios
  $('variant-radios .product-form__input input').on('click', function() {  
    setTimeout(printVariantAndReload, 100);
  });

});
